import { render, staticRenderFns } from "./TextAreaField.vue?vue&type=template&id=034fac12&scoped=true"
import script from "./TextAreaField.vue?vue&type=script&lang=js"
export * from "./TextAreaField.vue?vue&type=script&lang=js"
import style0 from "./TextAreaField.vue?vue&type=style&index=0&id=034fac12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034fac12",
  null
  
)

export default component.exports